import { render, staticRenderFns } from "./wordetaildialog.vue?vue&type=template&id=682fa94a&scoped=true&"
import script from "./wordetaildialog.vue?vue&type=script&lang=js&"
export * from "./wordetaildialog.vue?vue&type=script&lang=js&"
import style0 from "./wordetaildialog.vue?vue&type=style&index=0&id=682fa94a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682fa94a",
  null
  
)

export default component.exports